import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";

import { firebase } from "../firebase";
import * as routes from "../constants/routes";

const withAuthorization = condition => Component => {
  class WithAuthorization extends React.Component {
    static propTypes = {
      history: PropTypes.shape({}).isRequired,
      authUser: PropTypes.shape({})
    };
    static defaultProps = {
      authUser: null
    };

    componentDidMount() {
      firebase.auth.onAuthStateChanged(authUser => {
        if (!condition(authUser)) {
          const { history } = this.props;
          history.push(routes.HOME);
        }
      });
    }

    render() {
      const { authUser } = this.props;
      return authUser ? <Component /> : null;
    }
  }

  const mapStateToProps = (state, ownProps) => ({
    authUser: state.sessionState.authUser,
    match: ownProps.match
  });

  return compose(
    withRouter,
    connect(mapStateToProps)
  )(WithAuthorization);
};

export default withAuthorization;



// WEBPACK FOOTER //
// ./src/screens/withAuthorization.js